export default {
  nav: {
    services: 'Servicios',
    process: 'Cómo funciona',
    why: 'Por qué Kettelsen',
    book: 'Agenda una llamada'
  },
  hero: {
    eyebrow: 'Reclutamiento nearshore · Parte del grupo Kettelsen',
    title: 'Talento de primer nivel desde México, listo para tu equipo',
    subtitle: 'En Kettelsen identificamos, evaluamos y trasladamos a los profesionales que tu empresa en Estados Unidos necesita — gestionando el reclutamiento, la inmigración y la integración de principio a fin. El talento no conoce fronteras.',
    primaryCta: 'Agenda una llamada',
    secondaryCta: 'Cómo funciona',
    tagline: 'Inspirando movilidad, impulsando crecimiento.'
  },
  trust: {
    items: [
      {
        title: 'Talento especializado y evaluado',
        desc: 'Identificamos profesionales altamente calificados en tecnología, ingeniería, medicina y más — evaluados por habilidades y afinidad cultural.'
      },
      {
        title: 'Todo el proceso, resuelto',
        desc: 'Desde la búsqueda hasta las visas y el traslado, gestionamos todo el proceso de contratación e inmigración por ti.'
      },
      {
        title: 'Cumplimiento y agilidad',
        desc: 'Nuestra experiencia en reclutamiento internacional e inmigración asegura una transición fluida y de bajo riesgo para el talento y la empresa.'
      }
    ]
  },
  services: {
    eyebrow: 'Qué hacemos',
    title: 'Un solo socio para todo el proceso',
    subtitle: 'Somos tu solución integral — gestionamos cada necesidad de contratación e inmigración de principio a fin.',
    items: [
      {
        title: 'Búsqueda de talento',
        desc: 'Accedemos a un amplio grupo de profesionales especializados en México y el mundo, alineados con precisión a tus requerimientos.'
      },
      {
        title: 'Reclutamiento y selección',
        desc: 'Evaluación y entrevistas comprobadas para encontrar candidatos que encajen con el puesto, el equipo y tus objetivos.'
      },
      {
        title: 'Inmigración y visas',
        desc: 'Gestionamos todo el proceso de visa e inmigración, eliminando las barreras administrativas y legales del traslado.'
      },
      {
        title: 'Traslado e integración',
        desc: 'Acompañamiento en la adaptación cultural y el onboarding para que tus nuevas contrataciones se integren sin fricciones.'
      }
    ]
  },
  process: {
    eyebrow: 'Cómo funciona',
    title: 'De la necesidad a la contratación, en cuatro pasos',
    subtitle: 'Un proceso claro y ágil, diseñado para sumar a las personas correctas a tu equipo más rápido.',
    steps: [
      {
        title: 'Cuéntanos qué necesitas',
        desc: 'Comenzamos por entender tus puestos, habilidades requeridas y objetivos en una llamada inicial.'
      },
      {
        title: 'Buscamos y evaluamos',
        desc: 'Identificamos y evaluamos candidatos calificados y te presentamos una terna con los mejores perfiles.'
      },
      {
        title: 'Gestionamos contratación e inmigración',
        desc: 'Ofertas, contratos, visas e inmigración — gestionados de principio a fin por ti.'
      },
      {
        title: 'Talento integrado',
        desc: 'Acompañamos el traslado y el onboarding para que tu nuevo equipo se incorpore sin contratiempos.'
      }
    ]
  },
  why: {
    eyebrow: 'Por qué Kettelsen',
    title: 'Una forma más inteligente de hacer crecer tu equipo',
    subtitle: 'El talento nearshore da a las empresas de EE. UU. el alcance de la contratación global con la cercanía de trabajar al lado de casa.',
    points: [
      'Acceso a talento especializado en tecnología, ingeniería, medicina y más.',
      'Husos horarios alineados para colaborar en tiempo real con tus equipos en EE. UU.',
      'Profesionales bilingües listos para integrarse a tu cultura empresarial.',
      'Un proceso de contratación más rápido y rentable — sin atajos.',
      'Un único socio responsable de reclutamiento, inmigración e integración.'
    ],
    stats: [
      { value: '500+', label: 'Profesionales colocados' },
      { value: '98%', label: 'Retención de clientes' },
      { value: '30+', label: 'Industrias atendidas' },
      { value: '4 sem', label: 'Tiempo promedio a terna' }
    ],
    statsNote: '* Cifras de ejemplo — por confirmar con el equipo de Kettelsen.'
  },
  booking: {
    eyebrow: 'Hablemos',
    title: 'Agenda una llamada con nuestro equipo',
    subtitle: 'Elige el horario que mejor te convenga. Conoceremos tus necesidades de contratación y te mostraremos cómo Kettelsen puede ayudarte.',
    fallbackText: '¿Problemas para cargar el calendario?',
    fallbackCta: 'Abrir la página de agendado'
  },
  footer: {
    tagline: 'Reclutamiento internacional que conecta el talento global con oportunidades en Estados Unidos.',
    exploreTitle: 'Explora',
    servicesTitle: 'Servicios',
    contactTitle: 'Contacto',
    group: 'Parte del grupo Kettelsen. Servicios legales y de RR. HH. en México por Esquerra Jurídico.',
    rights: 'Todos los derechos reservados.',
    privacy: 'Aviso de Privacidad',
    terms: 'Términos del Servicio',
    contact: {
      address: 'San Luis Potosí, México',
      phone: '+52 444 000 0000',
      email: 'contacto@kettelsenmexico.com'
    }
  }
}
